import { useMutation } from 'react-query';

import { updateContract as mutationFn } from 'api/endPoints/updateContract';

export const useMutationRenameSubProgram = () => {
    return useMutation<any, QueryError, IRenameSubProgram>({ mutationFn: (params) => mutationFn(params) });
};

interface IRenameSubProgram {
    contractId: number;
    contractName: string;
}
